import { ComponentPropsWithoutRef, Ref } from 'react';

import { styles } from './InputOTPGroup.styles';

export type InputOTPGroupProps = {
  ref?: Ref<HTMLDivElement>;
} & ComponentPropsWithoutRef<'div'>;

export function InputOTPGroup({
  className,
  ref,
  ...props
}: InputOTPGroupProps) {
  const slots = styles();
  return (
    <div
      ref={ref}
      className={slots.base({ className })}
      {...props}
    />
  );
}

InputOTPGroup.displayName = 'InputOTPGroup';
